import React from "react";
import NavigationDrawer from "./NavigationDrawer";
import NavigationDesktop from "./NavigationDesktop";
import { Box } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";

const NavigationBar = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return <Box
  >{isDesktop ? 
  
  <NavigationDesktop /> : 
  <Box
    sx={{
      display: "flex",
      justifyContent:"flex-end",
      width: "90vw",
      margin: "1rem auto 0.5rem auto",
    }}
  >
<NavigationDrawer />

  </Box>
  }</Box>;
};

export default NavigationBar;
